<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">Copyright © 2022 <a href="https://www.netlinkdeal.com" target="_blank">NetLinkDeal</a>. Tous droits réservés.</p>
</footer>